import { EventEmitter, Injectable, Output } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UserPermissionModalComponent } from 'src/app/shared/modals/user-permission-modal/user-permission-modal.component';
import { UserModel } from '../../models/members/user/user.model';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionModalService {

  @Output() modelChanged = new EventEmitter<any>(); 

  constructor(  private modalService: NgbModal) { }

  openModal(model?: any) {
    var modalRef!: NgbModalRef;
        if(model == null){
          model = new UserModel(); 
        }
        modalRef = this.modalService.open( UserPermissionModalComponent, { windowClass : "customModalClassUnderName",size: 'lg', centered: false, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.model = model;
        var sub: Subscription =  modalRef.closed.subscribe(()=>{
          this.modelChanged.emit(true)
          sub.unsubscribe();
        })
  }
}